import Unit from "./Unit";

export default function BuildingB({ units, onToggle, onName }) {
  const row1 = ["19","20","21","22","23","24","25","26","27"];
  const row2 = ["36","35","34","33","32","31","30","29","28"];

  return (
    <div className="building">
      <h3>Building B</h3>

      <div className="grid grid-9 two-rows">
        {[...row1, ...row2].map((n) => (
          <Unit key={n} number={n} data={units[n]} onToggle={onToggle} onName={onName} />
        ))}
      </div>
    </div>
  );
}
